/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Material_CompositionInputs */

const en_field_material_composition = /** @type {(inputs: Field_Material_CompositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Composition`)
};

/**
* | output |
* | --- |
* | "Composition" |
*
* @param {Field_Material_CompositionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const field_material_composition = /** @type {((inputs?: Field_Material_CompositionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Material_CompositionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_field_material_composition(inputs)
});